import { gql } from '@apollo/client';

export const QUERY_PRODUCTS = gql`
  query getProducts($category_slug: String!) {
    productsInCategory(category_slug: $category_slug) {
      _id
      name
      description
      image
      sku
      price_usd
      weight
      active
      in_stock
      row_number
    }
  }
`;

export const QUERY_POSTS = gql`
  {
    posts {
      _id
      title
      post
      image
      active
    }
  }
`;

export const QUERY_POST = gql`
  query getPost($id: ID!) {
    post(_id: $id) {
      _id
      title
      post
      image
      active
      productLink
    }
  }
`;

export const QUERY_LINK = gql`
  query getLink($id: ID!) {
    link(_id: $id) {
      _id
      name
      dealText
      rating
      description
      image
      url
      ali {
        codeName
      }
    }
  }
`;

export const QUERY_LINKS = gql`
  query getLinks {
    links {
      _id
      name
      dealText
      rating
      description
      url
      image
      bannerImage
      active
      row_number
      ali {
        codeName
      }
    }
  }
`;

export const QUERY_VALIDATE_ORDER = gql`
  query validateOrder($lines: [OrderLineInput]!) {
    validate(lines: $lines) {
      _id
      name
      sku
      active
      in_stock
    }
  }
`;

export const QUERY_ALL_PRODUCTS = gql`
  {
    products {
      _id
      name
      description
      price
      quantity
      in_stock
      category {
        name
      }
    }
  }
`;

export const QUERY_CATEGORIES = gql`
  {
    categories {
      _id
      name
    }
  }
`;

export const QUERY_CATEGORY = gql`
  query getCategory($slug: String!) {
    category(slug: $slug) {
      _id
      name
      slug
    }
  }
`;

export const QUERY_USER = gql`
  {
    user {
      firstName
      lastName
      admin
      orders {
        _id
        purchaseDate
      }
    }
  }
`;
